import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useSelector } from "react-redux";

export default function SelectField({
  className,
  value,
  placeholder,
  handleChange,
  handleBlur,
  options,
  defaultValue,
  isMulti,
  isLoading,
  isDisabled,
  isClearable,
  labelName,
  menuPortalTarget,
  theme,
  closeMenuOnSelect,
  onFocus,
  innerRef,
  extraBgColor,
  isRVStyle = false,
}) {
  const layoutModeType = useSelector((state) => state.Layout.layoutModeType);

  const customStyles = {
    control: (styles, { isFocused }) => ({
      ...styles,
      borderRadius: "0.5rem",
      backgroundColor:
        extraBgColor ||
        (layoutModeType === "dark" && !isDisabled
          ? "#212529"
          : isDisabled
          ? "#EFF2F7"
          : "white"),
      color: layoutModeType === "dark" ? "white" : "black",
      borderColor:
        layoutModeType === "dark"
          ? isFocused
            ? "#0078A3"
            : "#495057"
          : "#ced4da",
      "&:hover": {
        borderColor: layoutModeType === "dark" ? "#0078A3" : "#80bdff",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isFocused ? "white" : provided.color,
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: layoutModeType === "dark" ? "#212529" : "#0078A3",
      color: "white",
    }),
  };

  const rvCustomStyles = {
    control: (styles, { isFocused, errors, touched }) => ({
      ...styles,
      borderRadius: "0.5rem",
      backgroundColor: isDisabled ? "#EFF2F7" : "white",
      color: "black",
      boxShadow: "none",
      borderColor: className?.includes("error-input") ? "#f06548" : "#ccc",
      "&:hover": {
        borderColor: className?.includes("error-input") ? "#f06548" : "grey",
      },
      maxHeight: "30px",
      overflowY: "auto",
      flexWrap: "wrap",
      fontWeight: "normal",
      fontSize: "14px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? "#f5f5f5"
        : state.isSelected
        ? "white"
        : "white",
      color: "black",
      fontWeight: "normal",
      fontSize: "14px",
      "&:hover": {
        backgroundColor: "#f5f5f5",
        filter: "brightness(0.95)",
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      fontWeight: "normal",
      fontSize: "14px",
      backgroundColor: state.isFocused
        ? "#f5f5f5"
        : state.isSelected
        ? "white"
        : "white",
      color: "black",
    }),
  };

  const animatedComponents = makeAnimated();

  return (
    <Select
      closeMenuOnSelect={closeMenuOnSelect}
      menuPortalTarget={menuPortalTarget}
      isLoading={isLoading}
      isMulti={isMulti}
      aria-labelledby={labelName}
      className={
        className?.includes("error-input") && isRVStyle ? "" : className
      }
      components={{
        ...animatedComponents,
        IndicatorSeparator: () => null,
      }}
      onFocus={onFocus}
      value={value}
      placeholder={placeholder}
      onChange={handleChange}
      onBlur={handleBlur}
      options={options}
      defaultValue={defaultValue}
      isDisabled={isDisabled}
      isClearable={isClearable}
      data-testid="valuetype"
      styles={rvCustomStyles}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: layoutModeType === "dark" ? "#495057" : "#015E7F",
          primary25: layoutModeType === "dark" ? "#343a40" : "#015E7F",
          primary50: layoutModeType === "dark" ? "#495057" : "#015E7F",
          primary75: layoutModeType === "dark" ? "#495057" : "#015E7F",
        },
      })}
      innerRef={innerRef}
      menuPosition="fixed"
      formatGroupLabel={ (data) => (
        <div>
          <div style={{backgroundColor:"#DFDFDF",color:"#000",padding:"5px 10px",fontWeight:"500",fontSize:"14px"}}>
            {data.label}
          </div>
        </div>
      )}
    />
  );
}
